import React from 'react'
import { toCurrentTimezoneHHMMA } from '../../config/global'
import HomeFutureMineralsPricesChange from '../home/future-minerals-last-month-prices/HomeFutureMineralsPricesChange'

export default function FutureMineralPricesMineralDetails({ mineral, lng }) {
  if (mineral)
    return (
      <div className="border-muted-300 flex border-2">
        <div className="bg-muted-300 p-2">
          <img
            className="!h-16 min-h-16 !w-16 min-w-16"
            src={`${process.env.REACT_APP_API_BASE_URL}/storage/minerals/${mineral.image}`}
            alt=""
          />
        </div>
        <div className="flex min-w-64 flex-col justify-between p-2">
          <div className="flex items-center justify-between gap-4">
            <div className="text-xl font-bold">{mineral[`name_${lng}`]}</div>
            <p className="text-secondary-600 text-lg font-bold">
              {` (${mineral?.unit_symbol}) `}
              <span dir="ltr">$ {mineral?.price}</span>
            </p>
          </div>
          <div className="flex items-center justify-between gap-4">
            <div
              dir="ltr"
              className="py-0.25 border-muted-300 flex border-2 bg-light px-2"
            >
              {toCurrentTimezoneHHMMA(mineral.price_date)}
            </div>
            <HomeFutureMineralsPricesChange change={mineral?.change} />
          </div>
        </div>
      </div>
    )
}
